import React, { Suspense, useEffect, useState, useMemo } from "react";
import { OrbitControls, Preload, useGLTF } from "@react-three/drei";
import * as THREE from "three";

import CanvasLoader from "../Loader";
import SafeCanvas from "./SafeCanvas"; // <-- ajusta ruta si no cuadra

const Computers = ({ isMobile }) => {
  const model = useGLTF("./models/planta/textured.glb");

  const centeredModel = useMemo(() => {
    const scene = model.scene.clone();
    const box = new THREE.Box3().setFromObject(scene);
    const center = box.getCenter(new THREE.Vector3());
    scene.position.sub(center);
    return scene;
  }, [model]);

  return (
    <mesh>
      <ambientLight intensity={0.9} />
      <directionalLight position={[5, 8, 5]} intensity={1.3} castShadow shadow-mapSize={1024} />
      <hemisphereLight intensity={0.4} groundColor="black" />
      <spotLight position={[-4, 6, 4]} angle={0.25} penumbra={1} intensity={1} castShadow />

      <primitive
        object={centeredModel}
        scale={0.88}
        position={[0.72, -0.95, 0]}
        rotation={[0, Math.PI, 0]}
      />
    </mesh>
  );
};

const Fallback = () => (
  <div className="w-full h-full min-h-[320px] rounded-xl bg-black/20 flex items-center justify-center">
    <p className="text-white/70 text-sm">Visual 3D no disponible en Firefox (WebGL).</p>
  </div>
);

const ComputersCanvas = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [controlsRef, setControlsRef] = useState(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 500px)");
    setIsMobile(mediaQuery.matches);
    const handleMediaQueryChange = (event) => setIsMobile(event.matches);
    mediaQuery.addEventListener("change", handleMediaQueryChange);
    return () => mediaQuery.removeEventListener("change", handleMediaQueryChange);
  }, []);

  useEffect(() => {
    if (controlsRef) {
      controlsRef.target.set(0.6, -0.5, 0);
      controlsRef.update();
    }
  }, [controlsRef]);

  return (
    <SafeCanvas
      fallback={<Fallback />}
      frameloop="demand"
      shadows
      camera={{ position: [0, 1.2, 3.5], fov: 40 }}
    >
      <Suspense fallback={<CanvasLoader />}>
        <OrbitControls
          ref={(ref) => setControlsRef(ref)}
          enableZoom={false}
          maxPolarAngle={Math.PI / 2}
          minPolarAngle={Math.PI / 2}
        />
        <Computers isMobile={isMobile} />
      </Suspense>
      <Preload all />
    </SafeCanvas>
  );
};

export default ComputersCanvas;